import { memo } from 'react';

import cls from './onboarding-progress-bar.module.css';

interface OnboardingProgressBarProps {
    currentStep: number;
    totalSteps: number;
}

export const OnboardingProgressBar = memo(
    (props: OnboardingProgressBarProps) => {
        const { currentStep, totalSteps } = props;

        const progressPercentage = Math.round((currentStep / totalSteps) * 100);

        return (
            <div className={cls.container}>
                <div className={cls.root}>
                    <div
                        className={cls.progressFill}
                        style={{ width: `${progressPercentage}%` }}
                    />
                </div>
            </div>
        );
    },
);

OnboardingProgressBar.displayName = 'OnboardingProgressBar';
